



































































































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { VideoPlayer } from "@/zh-website/src/components";
import { Icon } from 'ant-design-vue';
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import { Tooltip } from 'ant-design-vue';
@Component({
  components: {
    Swiper,
    SwiperSlide,
    VideoPlayer,
    Icon,
    Tooltip
  }
})
export default class Index extends Vue {
  url = "https://www.zj-huawei.com";
  videoW='982'
  videoH='292'
  mobilFlag=false
  modalVisible=false
  dataDetail:any={}
  SwiperBanner = {
    speed: 100,
    slidesPerView: 1,
    loop: false,
    autoplay: true
  };
  reportCon = {};
  bannerList = [];
  SwiperGuest = {
    slidesPerView: 3,
    observer: true,
    observeParents: true,
    centeredSlides:false,
    spaceBetween: 20,
    loop: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  guestList: any = [
    // {name:'肖苡',desc:'华为中国云与计算CTO',img:require("../../assets/report_01.jpg"),info:'负责华为中国区云与计算相关产业标准制定、政策设计和行业整体战略和技术发展蓝图规划。有二十多年ICT从业经验，对产业政策在行业中时实践、引领企业数字化转型、产品研发和管理、新技术在行业中的应用、生态构建有非常深刻的理解和丰富的经验。'},
    // {name:'肖苡',desc:'华为中国云与计算CTO',img:require("../../assets/report_01.jpg"),info:'负责华为中国区云与计算相关产业标准制定、政策设计和行业整体战略和技术发展蓝图规划。有二十多年ICT从业经验，对产业政策在行业中时实践、引领企业数字化转型、产品研发和管理、新技术在行业中的应用、生态构建有非常深刻的理解和丰富的经验。'},
    // {name:'肖苡',desc:'华为中国云与计算CTO',img:require("../../assets/report_01.jpg"),info:'负责华为中国区云与计算相关产业标准制定、政策设计和行业整体战略和技术发展蓝图规划。有二十多年ICT从业经验，对产业政策在行业中时实践、引领企业数字化转型、产品研发和管理、新技术在行业中的应用、生态构建有非常深刻的理解和丰富的经验。'},
    // {name:'肖苡',desc:'华为中国云与计算CTO',img:require("../../assets/report_01.jpg"),info:'负责华为中国区云与计算相关产业标准制定、政策设计和行业整体战略和技术发展蓝图规划。有二十多年ICT从业经验，对产业政策在行业中时实践、引领企业数字化转型、产品研发和管理、新技术在行业中的应用、生态构建有非常深刻的理解和丰富的经验。'}
  ];
  SwiperAgenda = {
    direction: "vertical",
    observer: true, //修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, //修改swiper的父元素时，自动初始化swiper
    loop: false, // 循环
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    slidesPerView: 3, // 每页显示几个slide
    speed: 600 // 速度
  };
  agendaPic = require("../../assets/report_02.jpg");
  agendaList: any = [
    // {title:'行稳致远，加速政企智能升级',time:'2019-05-05',desc:'郑叶来 华为公司副总裁、华为云业务总裁'},
    // {title:'行稳致远，加速政企智能升级',time:'2019-05-05',desc:'郑叶来 华为公司副总裁、华为云业务总裁'},
    // {title:'行稳致远，加速政企智能升级',time:'2019-05-05',desc:'郑叶来 华为公司副总裁、华为云业务总裁'},
    // {title:'行稳致远，加速政企智能升级',time:'2019-05-05',desc:'郑叶来 华为公司副总裁、华为云业务总裁'},
  ];
  imgUrl=require('../../assets/4.jpg')

  info = {
    img: require("../../assets/report_03.jpg"),
    desc:
      "随着数字化进程加速，大型政企“上云”和“智能化”进入到波澜壮阔的深水区。企业在本地数据中心部署的云基础设施，也到了一个新的历史转型期。"
  };
  SwiperMore = {
    slidesPerView: 4,
    observer: true,
    observeParents: true,
    spaceBetween: 20,
    centeredSlides:false,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1366: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  moreList: any = [
    // {title:'北京政务云北京政务云北京政务云北',img:require("../../assets/wireless7.jpg"),desc:'建设基于华为鲲鹏的创新云平台，提供差异化、高性能的算力资源，为复杂业务提供多元算力支撑。逐步上线首都之窗、移动公共服务平台、云管家等应用系统。'},
    // {title:'北京政务云北京政务云北京政务云北',img:require("../../assets/wireless7.jpg"),desc:'建设基于华为鲲鹏的创新云平台，提供差异化、高性能的算力资源，为复杂业务提供多元算力支撑。逐步上线首都之窗、移动公共服务平台、云管家等应用系统。'},
    // {title:'北京政务云北京政务云北京政务云北',img:require("../../assets/wireless7.jpg"),desc:'建设基于华为鲲鹏的创新云平台，提供差异化、高性能的算力资源，为复杂业务提供多元算力支撑。逐步上线首都之窗、移动公共服务平台、云管家等应用系统。'},
    // {title:'北京政务云北京政务云北京政务云北',img:require("../../assets/wireless7.jpg"),desc:'建设基于华为鲲鹏的创新云平台，提供差异化、高性能的算力资源，为复杂业务提供多元算力支撑。逐步上线首都之窗、移动公共服务平台、云管家等应用系统。'},
    // {title:'北京政务云北京政务云北京政务云北',img:require("../../assets/wireless7.jpg"),desc:'建设基于华为鲲鹏的创新云平台，提供差异化、高性能的算力资源，为复杂业务提供多元算力支撑。逐步上线首都之窗、移动公共服务平台、云管家等应用系统。'},
  ];
  screenWidth=0
  isPlay=false
  mounted() {
    this.getDetail(this.$route.params.aid)
    this.report();
    this.guests();
    this.agendas();
    this.mores();
    this.banners();
    this.screenWidth=document.documentElement.clientWidth
    window.onresize = () => {
      this.screenWidth=document.documentElement.clientWidth
      if(this.screenWidth>768){
        this.mobilFlag=false
       }else{
        this.modalVisible=false
       }
      }
  }
  async getDetail(id){
    const {data,success,message}:any=await NewsService.getReportDetail({id})
    if(success){
      this.dataDetail=data
      if(this.dataDetail.expandDetailResp.length>3&&this.screenWidth>1000||this.screenWidth<=1000&&this.dataDetail.expandDetailResp.length){
        this.SwiperMore.loop=true
        // this.SwiperMore.centeredSlides=false
        // this.SwiperMore.autoplay={
        //   delay: 2000,
        //   disableOnInteraction: false
        // }
      }else{
        // this.SwiperMore.centeredSlides=true
        this.SwiperMore.loop=false
        // this.SwiperMore.autoplay=false
      }

      if(this.dataDetail.agendaDetailResp.length>2){
        this.SwiperAgenda.loop=true
      }else{
        this.SwiperAgenda.loop=false
      }

      if(this.dataDetail.speakerDetailResp.length>2&&this.screenWidth>1000||this.screenWidth<=1000&&this.dataDetail.speakerDetailResp.length){
        this.SwiperGuest.loop=true
      }else{
        this.SwiperGuest.loop=false
      }
    }else{
      this.$message.error(message)
    }
  }
  closeModal(){
    (this.$refs.videoRef as any).$refs.video.pause()
    this.modalVisible=false
  }
  mobilClose(){
    this.mobilFlag=false
  }
  videoClick(){
    if(this.screenWidth>768){
      this.modalVisible=true
      this.$nextTick(()=>{
        // this.$refs.videoRef.$refs.video.play()
      })
    }else{
      this.mobilFlag=true
    }
  }
  jumpUrl(path) {
    if(!path)return
    window.open(path, "_blank");
    // console.log(path.indexOf("zj-huawei"))
    // if (path != "") {
    //   if (path.indexOf("zj-huawei") != -1) {
    //     window.location.href = path;
    //   } else {
    //     window.open(path, "_blank");
    //   }
    // }
  }
  async banners() {
    //
  }
  async mores() {
    this.moreList = [
      {
        imgUrl: "/file/2020-05-27/io50kC24IIe4yq7i40919Wgg16a1590563157658.JPG",
        isPush: 1,
        linkUrl: "http://www.chinazy.org/info/1016/3836.htm",
        id: "17zy0d41590563159542",
        title: "新基建下的5G应用型人才培养怎么做？",
        createDate: 1590563159000
      },
      {
        imgUrl: "/file/2020-05-20/4CUE23LP0wXc9z531O4X7195y871589937104900.jpg",
        updateDate: 1589937105000,
        isPush: 1,
        linkUrl: "http://www.zj-huawei.com/home/news/det/C9F72331589936992920",
        id: "34HHRe31589536613922",
        title: "看华为 5G 教学新品发布，赢华为 5G 手机！",
        createDate: 1589536613000
      },
      {
        imgUrl: "/file/2020-05-15/cfg7Wm89354390lH7piD74F09up1589536530423.jpg",
        updateDate: 1590493956000,
        isPush: 1,
        linkUrl: "",
        id: "R6NVx451589536531582",
        title: "一张图了解“5GStar”背后的星辰大海",
        createDate: 1589536531000
      },
      {
        imgUrl: "/file/2020-05-26/71r94L2MT3q4QH2sbO55Q27zu1N1590493662614.jpg",
        updateDate: 1590563100000,
        isPush: 1,
        linkUrl: "https://www.huawei.com/cn/press-events/news/2020/5/5gstrar",
        id: "SK369321589536457853",
        title: "华为发布“5GStar”超仿真训练系统，助力5G应用型人才培养",
        createDate: 1589536457000
      },
      {
        imgUrl: "/file/2020-05-15/HoSVsB4t77L9h48CzgN47EiN0411589536263523.jpg",
        updateDate: 1589536311000,
        isPush: 1,
        linkUrl:
          "http://www.zj-huawei.com/colleges/solve/profession/communication",
        id: "Mw9U05B1589448470344",
        title: "新空口、新架构：培养移动通信核心人才",
        createDate: 1589448470000
      }
    ];
  }
  async guests() {
    this.guestList = [
      {
        isPush: 1,
        headUrl:
          "/file/2020-05-18/2K515J3MWZZJi80p7nbRO5YPs3p1589762866267.jpg",
        id: "87Ria561589762867694",
        position: "华为5G产品线副总裁",
        sort: 1,
        content:
          "1999年加入华为公司，超过20年的电信从业经验，先后从事无线产品的预研、产品开发、无线全球市场营销及拓展等工作，丰富的运营商数字化转型咨询经验，2017年担任华为5G产品线副总裁，主管5G战略和产业发展工作。",
        guestName: "杜叶青",
        createDate: 1589762867000
      },
      {
        isPush: 1,
        headUrl:
          "/file/2020-05-18/ri27DS54b5Nb68XfeK9q490C6OR1589762807974.png",
        id: "8i8m8801589762810611",
        position: "华为5GStar总架构师",
        sort: 1,
        content:
          "在华为公司负责电信网络技术人才发展方案， 近20年通信领域研发、培训、工程经验，对移动通信网络2G到5G的网络技术演进、人才能力转型等领域有丰富的理论与实践经验。",
        guestName: "孙檀",
        createDate: 1589762810000
      },
      {
        isPush: 1,
        headUrl:
          "/file/2020-05-18/DExs6Cf566N6485F553065U52h71589762771286.jpg",
        id: "01t6N291589762772937",
        position: "浙江华为教育解决方案部部长",
        sort: 1,
        content:
          "负责浙江华为院校领域业务的战略规划、产品与解决方案策略制定、市场拓展与服务交付。有15年以上ICT及院校领域从业经验，对产业与教育政策、产品与解决方案规划、在线教育探索与应用、人才生态构建等领域均有独到视角与丰富的实战经验。",
        guestName: "赵爽",
        createDate: 1589762772000
      },
      {
        isPush: 1,
        headUrl:
          "/file/2020-05-18/74g604rM31Dt4D2LFac1al3f2911589762723596.jpg",
        id: "rvfjS661589762733418",
        position: "深圳职业技术学院副校长",
        sort: 1,
        content:
          "博士，教授，西安电子科技大学研究生导师。广东省教学名师、省优秀教学团队负责人，享受深圳市政府特殊津贴，国家级高层次领军人才。教育部高等学校创新创业教育指导委员会委员、教育部职业院校信息化教学指导委员会委员。",
        guestName: "马晓明",
        createDate: 1589762733000
      },
      {
        isPush: 1,
        headUrl:
          "/file/2020-05-18/R4iZau9516A27fE306707NHUV1t1589762687431.jpg",
        id: "c665GP91589762696478",
        position: "南京信息职业技术学院副校长",
        sort: 1,
        content:
          "南京信息职业技术学院副校长，二级教授，研究员级高级工程师，江苏省教学名师，江苏省第五期“333高层次人才培养工程”第二层次中青年领军人才。工信部通信专业指导委员会副主任委员、江苏省通信行业协会副理事长、“悉尼协议”应用研究高职联盟秘书长，长三角人工智能产教联盟秘书长。",
        guestName: "杜庆波",
        createDate: 1589762696000
      }
    ];
  }
  async agendas() {
    this.agendaList = [
      {
        updateDate: 1589532783000,
        isPush: 1,
        startTime: "15:00",
        id: "T0a43w61589424841267",
        endTime: "15:10",
        title: "星耀 · 5G加速，经济新动能",
        content: "杜叶青  华为5G产品线副总裁",
        createDate: 1589424841000
      },
      {
        updateDate: 1589531997000,
        isPush: 1,
        startTime: "15:10",
        id: "7G54DpA1589424829786",
        endTime: "15:25",
        title: "星闻 · 5G产业催生5G人才培养布局",
        content: "赵爽  浙江华为教育解决方案部部长",
        createDate: 1589424829000
      },
      {
        updateDate: 1589531927000,
        isPush: 1,
        startTime: "15:25",
        id: "5Gut0981589424818541",
        endTime: "15:40",
        title: "星赏 · 5GStar，解决5G应用型人才培养难题",
        content: "孙檀  华为5GStar技术总架构",
        createDate: 1589424818000
      }
    ];
  }

  async report() {
    const res = {
      tag1: 0,
      updateDate: 1589532545000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "活动简介",
      dictCode: "999",
      content1:
        "新技术带来新业态，新业态呼唤新基建，新基建需要新人才。当前5G进入规模商用，人才需求激增。如何实现高校教育与ICT行业用人需求的快速有效衔接，成为未来ICT行业与高校共同面临的问题。华为对准高校移动通信人才培养需求，推出5GStar超仿真训练系统，将虚拟仿真技术融入5G实训中，帮助高校创造更灵活、更真实的学习实验环境。5GStar不仅采用华为5G基站同源技术，更高度还原5G现网工作场景，为高校5G人才培养做好智力支撑。\n\n5月26日，华为5GStar超仿真训练系统在线发布，诚挚邀请您拨冗参加，与我们共赴技术的星辰大海！",
      field6: "了解更多",
      id: "1000",
      field3: "分享嘉宾",
      field2: "/file/2020-05-15/YDpBY7Qi84s95X8o164866TJ6601589524490265.png",
      field5: "/file/2020-05-14/u611a542U2e25N1240Lk6Y4425S1589443278182.jpg",
      group: "999",
      field4: "活动议程"
    };
    res.content1 = res.content1.replace(/\n/g, "<br/>");
    this.reportCon = res;
  }
  report_enter(type) {
    if (type == 1) {
      (this.$refs.guest as any).$swiper.autoplay.stop();
    } else if (type == 2) {
      (this.$refs.agenda as any).$swiper.autoplay.stop();
    } else {
      (this.$refs.more as any).$swiper.autoplay.stop();
    }
  }
  report_leave(type) {
    if (type == 1) {
      (this.$refs.guest as any).$swiper.autoplay.start();
    } else if (type == 2) {
      (this.$refs.agenda as any).$swiper.autoplay.start();
    } else {
      (this.$refs.more as any).$swiper.autoplay.start();
    }
  }
  videoPlay(e){
    this.isPlay=true
  }
  videoPause(e){
    this.isPlay=false
  }
}
